"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessages = void 0;
const gettext_1 = require("@integro/gettext");
const CONTEXT = 'DataTable';
function getMessages() {
    return {
        msgNoData: (0, gettext_1.pgettext)(CONTEXT, 'There is no data.'),
        msgCreateRow: (0, gettext_1.pgettext)(CONTEXT, 'Create'),
        msgConfirmDeleteRow: (0, gettext_1.pgettext)(CONTEXT, 'Please confirm deleting the selected record.'),
        msgConfirmDeleteRowHeader: (0, gettext_1.pgettext)(CONTEXT, 'Confirm delete'),
        msgConfirmDeleteRowBtnOK: (0, gettext_1.pgettext)(CONTEXT, 'Delete'),
        msgEdit: (0, gettext_1.pgettext)('DataTableRow', 'Edit'),
        msgSave: (0, gettext_1.pgettext)('DataTableRow', 'Save'),
        msgCancel: (0, gettext_1.pgettext)('DataTableRow', 'Cancel'),
        msgDelete: (0, gettext_1.pgettext)('DataTableRow', 'Delete')
    };
}
exports.getMessages = getMessages;
//# sourceMappingURL=messages.js.map